// src/utils/scroll-animation.js
const map = new WeakMap();

function isBelowViewport(el) {
  const rect = el.getBoundingClientRect();
  const isBelow = rect.top > window.innerHeight;
  return isBelow;
}

const ob = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      const animation = map.get(entry.target);
      if (animation) {
        animation.play();
        ob.unobserve(entry.target);
        map.delete(entry.target); // 清理引用
      }
    }
  }
});

export default {
  bind(el, binding) {
  },
  
  inserted(el, binding) {
    // 检查浏览器是否支持 Web Animations API
    if (!el.animate) {
      return;
    }
    
    try {
      // 判断元素是否在视口下方
      const belowViewport = isBelowViewport(el);
      
      // 创建动画
      const animation = el.animate([
        {
          transform: `translateY(100px)`,
          opacity: 0.5,
        },
        {
          transform: `translateY(0px)`,
          opacity: 1,
        }
      ], {
        duration: 800,
        easing: 'ease-out',
        fill: 'forwards'
      });
      
      if (belowViewport) {
        // 如果元素在视口下方，暂停动画并观察元素
        animation.pause();
        map.set(el, animation);
        ob.observe(el);
      } else {
        // 如果元素已经在视口内，直接播放动画
        animation.play();
      }
    } catch (error) {
    }
  },
  
  unbind(el) {
    if (ob) {
      ob.unobserve(el);
    }
    if (map.has(el)) {
      map.delete(el);
    }
  }
}